export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13191.427c7f06.jpg";